"use strict";
window.theme = window.theme || {}
theme.ComponentsFooter = function() {
    function ComponentsFooter() {
        this.container = {
            captcha: [
                document.querySelector('.Newsletter__Footer__Inner .newsletter-captcha-block label #newsletter-captcha'),
                document.querySelector('.contact-form .contact-captcha-block label #contact-captcha')

            ]
        };
        this.button = {
            toggle: document.querySelectorAll('#section-footer > .Container > .Footer__Inner > .Footer__Block'),
            nl_submit: document.querySelector('.Newsletter__Footer__Inner #news-letter-signup-button'),
            contact_submit: document.querySelector('.contact-form button#contact-submit-2')
        };
        this.cart = {
        }
        this.load();               

    }
    ComponentsFooter.prototype.load = function() {
        var _ = this;

        window.onloadCallback = (e) => {	   
            grecaptcha.ready(() => {
                /* Rendering captcha */
                _.container.captcha.forEach(elm => {
                    if(elm){
                        let submit_btn = elm.getAttribute('data-target');
                        let renderCaptcha = grecaptcha.render(elm, {
                            'sitekey' : '6LcKF5IoAAAAAAaG0xrPUcb0PxBUdDpz2h0vGv2S',
                            'callback':function() {
                                _.button[submit_btn].removeAttribute('disabled');
                            },
                            "expired-callback": function() {
                                _.button[submit_btn].setAttribute('disabled', 'disabled');
                            },
                            'error-callback': function(err) {
                              grecaptcha.reset(renderCaptcha)
                            }
                        })
                    }
                })
            });
        }
        if(_.button.toggle.length > 0) {
            _.button.toggle.forEach(btn => {
                btn.addEventListener('click', event => {
                    event.target.closest('.Footer__Block').classList.toggle('active');
                })
            })
        }
    }

    theme.ComponentsFooter = new ComponentsFooter;
}

theme.ComponentsFooter();

(function() {
    setTimeout( () => {
        let cookieLink = document.querySelector(".legal-menus .ot-sdk-show-settings");
        cookieLink.innerHTML = 'COOKIE PREFERENCES';
    }, 2000);
 
 })();

//  Mobile cookie
(function() {
    setTimeout( () => {
        let cookieLinkMobile = document.querySelector(".cookie-link .ot-sdk-show-settings");
        cookieLinkMobile.innerHTML = 'COOKIE PREFERENCES';
    }, 2000);
 
 })();